import { types } from 'constants/Partner/OutletWallet';

const initialState = {
    pOutlet: {
        list: {
            loading: false,
            error: '',
            data: [],
            page: 1,
            totalPage: null,
            totalData: 0,
        },
    },
};

const outlet = (state = initialState.pOutlet, action) => {
    switch (action.type) {
        case types.GET_PARTNER_OUTLET_LOADING:
            return {
                ...state,
                list: {
                    ...state.list,
                    loading: true,
                },
            };
        case types.GET_PARTNER_OUTLET_SUCCESS:
            return {
                ...state,
                list: {
                    ...state.list,
                    loading: false,
                    data: action.data,
                    totalPage: parseInt(action.totalPage),
                    totalData: parseInt(action.totalData),
                    page: action.page || state?.list?.page,
                },
            };
        case types.GET_PARTNER_OUTLET_FAILED:
            return {
                ...state,
                list: {
                    ...state.list,
                    loading: false,
                    error: action.message,
                },
            };

        default:
            return state;
    }
};

export default outlet;
